import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

// Login API
export const login = async (email, password) => {
  try {
    const response = await apiService.post(apiRoutes.login, {
      email,
      password,
    });
    localStorage.setItem("authToken", response.data.body.token);
    localStorage.setItem("authUser", JSON.stringify(response.data.body.user));
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data.message || "Login failed");
  }
};

export const userSignup = async (payload) => {
  try {
    const response = await apiService.post(apiRoutes.signup, payload);
    if (response.success == true && response.data.body.user.role === "user") {
      localStorage.setItem("authToken", response.data.body.token);
      localStorage.setItem("authUser", JSON.stringify(response.data.body.user));
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.message || "Login failed");
  }
};

export const forgotPassword = async (payload) => {
  try {
    const response = await apiService.post(apiRoutes.forgotPassword, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data.message || "Login failed");
  }
};

export const resetPassword = async (payload) => {
  try {
    const response = await apiService.post(apiRoutes.resetPassword, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data.message || "Login failed");
  }
};

export const socialLogin = async (payload) => {
  try {
    const response = await apiService.post(apiRoutes.socialLogin, payload);
    localStorage.setItem("authToken", response.data.body.token);
    localStorage.setItem("authUser", JSON.stringify(response.data.body.user));
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data.message || "Login failed");
  }
};

export const verifyLinkedIn = async (redirect="") => {
  const baseUrl = "http://xuthority.indiitserver.in";
  const redirectUrl = encodeURIComponent(`${baseUrl}${redirect}`);
  window.location.href = `${apiRoutes.verifyLinkedIn}?redirect=${redirectUrl}`;
};

export const loginLinkedIn = async (redirect = "",role='user') => {
  const baseUrl = "http://xuthority.indiitserver.in";
  const redirectUrl = encodeURIComponent(`${baseUrl}${redirect}`);
  window.location.href = `${apiRoutes.linkedInLogin}?role=${role}&redirect=${redirectUrl}`;
};


// Logout
export const logout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("authUser");
  window.location.reload("/");
};

export const getIndustriesList = async (page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.getIndustriesList, {
    page,
    limit,
  });
  return response.data;
};
export const getCompanySizesList = async (page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.getCompanySizesList, {
    page,
    limit,
  });
  return response.data;
};
export const getRegionsList = async (page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.getRegionsList, {
    page,
    limit,
  });
  return response.data;
};



export const getMyProfileDetails = async () => {
  const response = await apiService.get(apiRoutes.getMyProfileDetails);
  return response.data;
};
export const updateProfile = async (payload) => {
  const response = await apiService.post(apiRoutes.updateProfile, payload);
  localStorage.setItem("authUser", JSON.stringify(response.data.body));
  return response.data;
};

export const fileUpload = async (file) => {
  const formData = new FormData();
  formData.append("image", file);
for (let [key, value] of formData.entries()) {
  console.log(`${key}: sdasdsad`, value);
}
  const response = await apiService.post(apiRoutes.fileUpload, formData);
  return response.data;
};

export const changePassword = async (payload) => {
  const response = await apiService.post(apiRoutes.changePassword, payload);
  return response.data;
};

export const getOtherProfileDetails = async (id) => {
  const response = await apiService.get(
    `${apiRoutes.getOtherProfileDetails}?id=${id}`
  );
  return response.data;
};

export const getUserProductList = async (userId, page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.getUserProductList, {
    userId,
    page,
    limit,
  });
  return response.data;
};

export const verifyResetToken = async (token) => {
  const response = await apiService.get(
    `${apiRoutes.verifyResetToken}?token=${token}`
  );
  return response.data;
};